// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_3oD1Fpf5Eq35ZmfoUaTcG","tableWrapper":"_1zNA7kMIE4CdyqU84BgZ5M","tableWrapperResponsive":"_2TIuGHxBYWSuhcggqDECkY"};